import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PopupService {
  private popups: any[] = [];
  private closeAllPopupsSubject = new Subject<void>();

  closeAllPopups$ = this.closeAllPopupsSubject.asObservable();

  registerPopup(popup: any) {
    this.popups.push(popup);
  }

  unregisterPopup(popup: any) {
    this.popups = this.popups.filter(p => p !== popup);
  }

  closeAllPopups() {
    this.closeAllPopupsSubject.next();
    this.popups.forEach(popup => popup.close());
    this.popups = [];
  }
}
